import {useLocation, Link} from "react-router-dom";
import {useTranslation,} from "react-i18next";

// Data
import { serviceDetailList } from "../../data/serviceDetailList";

const ServiceDetailPage = () => {

    const { t } = useTranslation(); 

    const location = useLocation();
    const activeServiceSlug = location.pathname.split("/").pop();

    const activeService = serviceDetailList.find(service => service.slug === activeServiceSlug);

    return (
        <main id="service-detail-page" className="space-ptb">
            <div className="container-fluid w-special">
                <h1>{t(activeService?.title || "")}</h1>
                <p className="mb-5">{t(activeService?.shortDesc || "")}</p>
                <div className="row">
                    <div className="col-12 col-lg-8 align-self-center order-lg-1">
                        <div className="mb-4 mb-lg-5">
                            <img src={activeService?.imagePath || ""} alt={t(activeService?.title || "") as string} className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-12 align-self-center order-lg-3">
                        <section className="service-detail-content mb-4 mb-lg-5">
                            {activeService?.content && (
                                <activeService.content />
                            )}
                        </section>
                    </div>
                    <div className="col-12 col-lg-4 order-lg-2">
                        <div className="mb-4 mb-lg-5 all-services-links">
                            <h2 className="mb-3">{t("serviceDetailPage.subTitle")}</h2>
                            { serviceDetailList.map((service, index) => (
                                <Link to={`/servizio/${service.slug}`} className={ activeService?.slug === service.slug ? "active" : ""} key={index}>
                                    {t(service.title)}
                                </Link>
                            )) }
                            <Link to="/contatti" className="btn btn-primary w-100 mt-3">
                                <span>{t("serviceDetailPage.btnContactUs")}</span>
                                <span>{t("serviceDetailPage.btnContactUs")}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    );
};

export default ServiceDetailPage;